var _rect, _rect2, _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#A9C1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3204_40670",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#A9C1FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3204_40670)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 5.94141,
    y: 13.9072,
    width: 23,
    height: 30.4884,
    rx: 4.27907,
    transform: "rotate(30 5.94141 13.9072)",
    fill: "#173C99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1045,
    y: 9.09326,
    width: 23,
    height: 30.4884,
    rx: 4.27907,
    transform: "rotate(30 16.1045 9.09326)",
    fill: "url(#paint0_linear_3204_40670)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 7.40698,
    cy: 5.40698,
    r: 2.40698,
    fill: "#173C99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3204_40670",
    x1: 18.7335,
    y1: 10.9724,
    x2: 29.4024,
    y2: 23.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01017C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.ef3d8167d8e664a297984eb6e4cc4710.svg";
export { ForwardRef as ReactComponent };